
// 현금 세자리 컴마
const currency = (val) => {
  console.log(val)
  if (!val) return 0
  val = Number(val)
  return val.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
}

// 오늘 날짜 2020-01-01 형식으로 얻기
const dataType = (val, type) => {
  if (!type) type = '-'
  let year = 0
  let month
  let day = 0
  let today

  // 비정상 적인 모습으로 오면 오늘 날짜

  if (!val || val.length < 9) {
    today = new Date()
  } else {
    today = new Date(val)
  }

  year = today.getFullYear()
  month = today.getMonth() + 1
  day = today.getDate()

  if (month < 10) month = '0' + month
  if (day < 10) day = '0' + day

  return year + type + month + type + day
}

const dateTime = (val, type) => {
  if (!type) type = ':'
  if (!val || val.length !== 6) return '00' + type + '00' + type + '00'
  val = val.substring(0, 2) + type + val.substring(2, 4) + type + val.substring(4, 6)
  return val
}

// 현재달의 첫날구하기 flag : true 01 false 면 현재 날자
const currentDay = ( flag ) => {
  const todayDate = new Date()
  const todayYear = todayDate.getUTCFullYear()
  const todayMonth = Number(todayDate.getUTCMonth()) + 1 < 10 ? '0' + (Number(todayDate.getUTCMonth()) + 1) : Number(todayDate.getUTCMonth()) + 1
  const todayDay = Number(todayDate.getUTCDate()) < 10 ? '0' + todayDate.getUTCDate() : todayDate.getUTCDate()
  return (flag ?  todayYear + '-' + todayMonth + '-01' : todayYear + '-' + todayMonth + '-' + todayDay)
}

export {
  currency,
  dataType,
  dateTime,
  currentDay
}
